<template>
  <div id="_2025_3">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h">
            Announcement of IGU MGSC Awards 2025
        </strong>
      </h3>
      <hr />
      <p>
          After careful consideration by the awards committee, the IGU MGSC Awards 2025 were announced.
      </p><br>
      
      <p>
        These awards were organized and judged by the Modeling Geographical Systems Commission of IGU. They aim to recognize outstanding academic contributions in the field of geographic modeling research and promote innovation and development in modeling geographic systems.
      </p><br>
      <p>
        This time, one winner of the Outstanding Achievement Award (OAA) and two winners of the Excellent Young Scholar Award (YSA) were selected. The awardee list is as follows:
      </p><br>

      <h5>OAA in Modeling Geographical Systems</h5>
      <div class="man">
        <p><strong>Prof. Luc Anselin</strong></p>
        <img src="../../../assets/static/img/Events/Prof. Luc Anselin.png" alt="">
        <p><strong>University of Chicago, US</strong></p>
      </div>

      <h5>YSA in Modeling Geographical Systems</h5>
      <div class="flex">
        <div class="man" style="margin-right: 100px;">
          <p><strong>Dr. Gengchen Mai</strong></p>
          <img src="../../../assets/static/img/Events/Dr. Gengchen Mai.png" alt="">
          <p><strong>University of Texas at Austin, US</strong></p>
        </div>
        <div class="man">
          <p><strong>Dr. Chao Yang</strong></p>
          <img src="../../../assets/static/img/Events/Dr. Chao Yang.png" alt="">
          <p><strong>Shenzhen University, China</strong></p>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: '_2025_3'
};
</script>
<style scoped lang="less">
#_2025_3 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  line-height: 2rem;
  text-align: justify;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h4 {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}
h5 {
  font-weight: bold;
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
  color: #1a80b6;
}
.home-date {
  font-weight: bold;
  color: grey;
}

a {
  text-decoration: none;
}
p {
  margin-bottom: 0;
}
.pic {
  // display: table-cell;
  text-align: center;
  height: 128px;
  width: 128px;
  overflow: hidden;
}
.flex {
  display: flex;
  justify-content: center;
}
.man {
    text-align: center;
    margin-bottom: 30px;
    position: relative;
}

</style>
